<template>
  <input 
    type="tel" 
    ref="input" 
    :value="value" 
    @input="$emit('input', $refs.input.value)"
  >
</template>

<script>
export default {
  name: 'iPhoneField',
  props: ['value'],
};
</script>

